import "../style/whyChooseUs.css";
import React from "react";
import { ShoppingBag, Truck, ClipboardCheck, Leaf } from "lucide-react";

const features = [
  {
    icon: <ShoppingBag />,
    title: "Multiple Bin Sizes",
    desc: "2m³ to 10m³ bins to suit every project",
  },
  {
    icon: <Truck />,
    title: "Quick Delivery",
    desc: "Prompt delivery and pickup, when you need it",
  },
  {
    icon: <ClipboardCheck />,
    title: "Easy Booking",
    desc: "Simple online booking in just a few clicks",
  },
  {
    icon: <Leaf />,
    title: "Sustainable Solutions",
    desc: "We recycle and dispose of waste responsibly",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="feature-strip">
      <div className="feature-strip-inner">
        {features.map((item, index) => (
          <div className="feature-item" key={index}>
            <div className="feature-iconn">{item.icon}</div>
            <div className="feature-text">
              <h4>{item.title}</h4>
              <p dangerouslySetInnerHTML={{ __html: item.desc }} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;